import React from 'react';

import FormErrors from '../../Services/FormErrors';

import { FormContext } from './context';

class FormContextProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitted: false,
      submit: this.submit,
      cancel: this.cancel
    };
  }

  _checkErrors = (errors) => {
    for (const key in errors) {
      if (errors[key]) {
        return true;
      }
    }
    return false;
  };

  submit = async (submit, errors) => {
    const { isSubmitted } = this.state;
    if (!isSubmitted) {
      this.setState({ isSubmitted: true });
    }
    if (!this._checkErrors(errors)) {
      return await submit();
    }
    FormErrors.goToError();
    return false;
  };

  cancel = (cancel) => {
    this.setState({
      isSubmitted: false
    });
    if (cancel) {
      cancel();
    }
  };

  render() {
    return <FormContext.Provider value={this.state}>{this.props.children}</FormContext.Provider>;
  }
}

export default FormContextProvider;
